/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  selectDraftVersion,
  selectKfa,
  selectedVersionStatus,
  updateSelectionVersion,
  updateVersions,
} from 'features/hypotheses/hypothesisSlice';

import { VersioningEventPayload, VersioningProps } from '../types';
import VersioningMFE from '../VersioningMFE';

export const KFAVersioning: React.FunctionComponent<VersioningProps> = (
  props
) => {
  const dispatch = useDispatch();
  const { projectId } = useParams<{
    hypothesisId: string;
    projectId: string;
  }>();
  const draftVersion = useSelector(selectDraftVersion) as null | {
    readonly contentId: number;
  };
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const selectedVersion = useSelector(
    selectedVersionStatus
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any as null | {
    readonly contentId?: number;
  };
  const rawKfa = useSelector(selectKfa);
  const kfa = (rawKfa || { content: undefined }).content;

  const handleVersionUpdate = useCallback(
    (versionsPayload: VersioningEventPayload) => {
      const { draft: current, shared } = versionsPayload;
      const contentId = shared.isSelected
        ? shared.contentId
        : current.contentId;

      if (selectedVersion?.contentId !== contentId) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(updateSelectionVersion({ contentId }));
      }

      const versions = [current, shared];
      dispatch(updateVersions(versions));
    },
    [dispatch, selectedVersion]
  );

  return (
    <VersioningMFE
      {...props}
      contentThreadId={kfa?.contentThreadId}
      currentVersionId={draftVersion?.contentId}
      handleVersionUpdate={handleVersionUpdate}
      projectId={projectId}
      selectedContentId={selectedVersion?.contentId}
    />
  );
};

export default KFAVersioning;
